import "core-js/modules/es.function.name";
import parser from 'ua-parser-js';

var uaToDeviceType = function uaToDeviceType(uaString) {
  var ua = parser(uaString);

  if (ua.device.type === undefined) {
    return "";
  }

  return ua.device.type;
};

var uaToOSName = function uaToOSName(uaString) {
  var ua = parser(uaString);
  return ua.os.name;
};

export { uaToDeviceType, uaToOSName };